module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pulmonology3@3x.a41c80f4.png";